
import { withStyles } from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import * as React from 'react';
import styled from 'styled-components';
import { DSAlert, DSAlertTitle, DSAccordion, DSAccordionSummary, DSAccordionDetails, DSTypography } from '../mui';

const StyledDSAccordion = withStyles({
    expanded: {
        margin: '0 !important',
    },
    root: {
        '&:before': {
            display: 'none',
        },
        background: 'none',
        boxShadow: 'none',
    },
})(DSAccordion);

const StyledDSAccordionSummary = withStyles({
    root: {
        '&:hover': {
            'background-color': 'rgba(255, 0, 0, 0.03)',
        },
        '&> *': {
            margin: '6px 0px !important',
        },
        'justify-content': 'start',
        'min-height': '0 !important',
        padding: '0px 5px',
        'text-decoration': 'underline',
    },
})(DSAccordionSummary);

const StyledDSAccordionDetails = withStyles({
    root: {
        padding: 0,
    },
})(DSAccordionDetails);

const StyledPre = styled.pre`
    background-color: rgba(255, 255, 255, 0.2);
    border-color: rgba(255, 0, 0, 0.1);
    max-width: 100%;
    overflow-x: auto;
`;

export interface ErrorMessageProps {
    children?: React.ReactNode;
    error?: Error;
    title?: string;
    message?: string;
    hideStacktrace?: boolean;
}

export const ErrorMessage: React.FC<ErrorMessageProps> = ({ children, error, hideStacktrace, message, title }) => (
    <DSAlert severity="error">
        {title && <DSAlertTitle>{title}</DSAlertTitle>}
        <DSTypography color="inherit">{message}</DSTypography>
        {children}
        {error && !hideStacktrace && (
            <StyledDSAccordion square={true}>
                <StyledDSAccordionSummary expandIcon={<ExpandMoreIcon />}>
                    <DSTypography color="inherit">
                        {error.message && error.message.length > 0
                            ? error.message
                            : error.stack
                            ? `${error.stack.slice(0, Math.min(error.stack.length, 50))}${
                                  error.stack.length > 50 ? '...' : ''
                              }`
                            : error.name}
                    </DSTypography>
                </StyledDSAccordionSummary>
                <StyledDSAccordionDetails>
                    <StyledPre>{error.stack}</StyledPre>
                </StyledDSAccordionDetails>
            </StyledDSAccordion>
        )}
    </DSAlert>
);
